/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  TextField,
} from "@mui/material";
import CustomTabs from "components/Tabs";
import openCloudinaryWidget from "utils/cloudinary";
import { usePost } from "hooks/usePost";
import TagsAutocomplete from "components/TagsAutocomplete";
import { CONFLUENCE_FILES, CONFLUENCE_FOLDERS } from "constants/services";
import AttachFileIcon from "@mui/icons-material/AttachFile";

const ImageLibraryDialog = ({
  open,
  onClose,
  onImageSelect,
  folder,
  apiUrl,
  uploadedFileType,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const { mutateAsync } = usePost();

  const handleTabChange = (newValue) => {
    setActiveTab(newValue);
  };

  const handleUpload = (f) => {
    openCloudinaryWidget(folder, [], async (result) => {
      if (result?.secure_url) {
        await mutateAsync({
          url: CONFLUENCE_FILES,
          data: {
            ...result,
            folderName: f?.folderName || f?.value,
            uploadedFileType,
          },
        });
        onImageSelect(result);
        setActiveTab(0);
        // onClose();
      }
    });
  };

  const handleLibraryImageSelect = (imageUrl) => {
    onImageSelect(imageUrl);
    onClose();
  };

  const tabs = ["Library", "Upload"];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <div>Select Image</div>
          <CloudUploadIcon />
        </div>
      </DialogTitle>
      <DialogContent>
        <CustomTabs tabs={tabs} value={activeTab} onTabChange={handleTabChange}>
          <Box sx={{ py: 2 }}>
            {activeTab === 0 && (
              <LibraryTab
                onImageSelect={handleLibraryImageSelect}
                apiUrl={apiUrl}
              />
            )}
            {activeTab === 1 && <UploadTab onUpload={handleUpload} />}
          </Box>
        </CustomTabs>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

// Library Tab Component
const LibraryTab = ({ onImageSelect, apiUrl }) => {
  const { mutateAsync } = usePost();
  const [search, setSearch] = useState("");
  const [images, setImages] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);

  const fetchImages = async () => {
    const { data } = await mutateAsync({
      url: apiUrl,
    });
    setImages(data);
  };

  useEffect(() => {
    fetchImages();
  }, []);

  // Extract unique folders from images
  const folders = React.useMemo(() => {
    const folderSet = new Set();
    images.forEach((image) => {
      if (image?.folderName) {
        folderSet.add(image.folderName);
      }
    });
    return Array.from(folderSet).sort();
  }, [images]);

  // Filter images based on selected folder and search
  const filteredImages = React.useMemo(() => {
    let filtered = images;

    // Filter by folder
    if (selectedFolder) {
      filtered = filtered.filter(
        (image) => image?.folderName === selectedFolder
      );
    }

    // Filter by search
    if (search) {
      filtered = filtered.filter((image) =>
        image?.original_filename?.toLowerCase().includes(search.toLowerCase())
      );
    }

    return filtered;
  }, [images, selectedFolder, search]);

  return (
    <Box>
      {/* Search Bar */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <Typography variant="h6" gutterBottom>
          Select from Library
        </Typography>

        <TextField
          label="Search"
          size="small"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setSelectedFolder(null);
          }}
          placeholder="Search by filename..."
        />
      </div>

      {/* Two Column Layout: Folders (30%) and Images (70%) */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          minHeight: "400px",
        }}
      >
        {/* Section 1: Folders (30% width) */}
        <Box
          sx={{
            width: "30%",
            borderRight: "1px solid #e0e0e0",
            paddingRight: 2,
            overflowY: "auto",
            maxHeight: "500px",
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2 }}>
            Folders
          </Typography>

          {/* All Files Option */}
          <Box
            onClick={() => setSelectedFolder(null)}
            sx={{
              padding: "10px",
              cursor: "pointer",
              borderRadius: "4px",
              marginBottom: "8px",
              backgroundColor: selectedFolder === null ? "#000" : "transparent",
              color: selectedFolder === null ? "#fff" : "#000",
              "&:hover": {
                backgroundColor: selectedFolder === null ? "#000" : "#f5f5f5",
              },
              transition: "all 0.2s",
            }}
          >
            <Typography variant="body2">
              All Files ({images.length} assets)
            </Typography>
          </Box>

          {/* Individual Folders */}
          {folders.map((folder, index) => {
            const folderImageCount = images.filter(
              (img) => img?.folderName === folder
            ).length;

            return (
              <Box
                key={index}
                onClick={() => setSelectedFolder(folder)}
                sx={{
                  padding: "10px",
                  cursor: "pointer",
                  borderRadius: "4px",
                  marginBottom: "8px",
                  backgroundColor:
                    selectedFolder === folder ? "#000" : "transparent",
                  color: selectedFolder === folder ? "#fff" : "#000",
                  "&:hover": {
                    backgroundColor:
                      selectedFolder === folder ? "#000" : "#f5f5f5",
                  },
                  transition: "all 0.2s",
                }}
              >
                <Typography variant="body2">
                  {folder} ({folderImageCount} assets)
                </Typography>
              </Box>
            );
          })}

          {folders.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              No folders available
            </Typography>
          )}
        </Box>

        {/* Section 2: Images (70% width) */}
        <Box
          sx={{
            width: "70%",
            overflowY: "auto",
            maxHeight: "500px",
            paddingLeft: 2,
          }}
        >
          {filteredImages?.length > 0 && (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
                gap: 2,
              }}
            >
              {filteredImages?.map((image, index) => (
                <Box
                  key={index}
                  sx={{
                    cursor: "pointer",
                    border: "2px solid transparent",
                    overflow: "hidden",
                  }}
                  onClick={() => onImageSelect(image)}
                >
                  {image?.secure_url?.includes(".png") ||
                  image?.secure_url?.includes(".jpg") ||
                  image?.secure_url?.includes(".jpeg") ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        border: "2px solid #000",
                        borderRadius: 5,
                        padding: 1,
                        alignItems: "center",
                        justifyContent: "center",
                        paddingTop: 4,
                        paddingBottom: 4,
                      }}
                    >
                      <img
                        src={image?.secure_url}
                        alt={`Library image ${index + 1}`}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "contain",
                        }}
                      />
                      <div>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            fontSize: "0.75rem",
                            textAlign: "center",
                            wordBreak: "break-word",
                          }}
                        >
                          {image?.original_filename}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            fontSize: "0.75rem",
                            textAlign: "center",
                            wordBreak: "break-word",
                            fontWeight: "bold",
                          }}
                        >
                          Folder:{image?.folderName}
                        </Typography>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        border: "2px solid #000",
                        borderRadius: 5,
                        padding: 1,
                        alignItems: "center",
                        justifyContent: "center",
                        paddingTop: 4,
                        paddingBottom: 4,
                        flexDirection: "column",
                        gap: 2,
                      }}
                    >
                      <AttachFileIcon style={{ fontSize: "50px" }} />
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          fontSize: "0.75rem",
                          textAlign: "center",
                          wordBreak: "break-word",
                        }}
                      >
                        {image?.original_filename}
                      </Typography>
                    </div>
                  )}
                </Box>
              ))}
            </Box>
          )}

          {!filteredImages?.length && (
            <Typography variant="body2" color="text.secondary">
              {search || selectedFolder
                ? "No images found matching your criteria"
                : "No images found"}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

const UploadTab = ({ onUpload }) => {
  const [folder, setFolder] = useState("");

  return (
    <Box>
      <TagsAutocomplete
        createable
        optionApiKey="folderName"
        apiEndPoint={CONFLUENCE_FOLDERS}
        title="Add Folder"
        subTitle="Add a new Folder"
        value={folder || { title: "", value: "" }}
        setValue={(v) => setFolder(v)}
        label="Select Folder Name"
        multiple={false}
      />
      <div
        style={{
          border: "1px dashed black",
          borderRadius: 5,
          padding: 10,
          marginTop: 10,
          textAlign: "center",
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 10,
          borderColor: folder ? "black" : "gray",
          opacity: folder ? 1 : 0.5,
          cursor: folder ? "pointer" : "not-allowed",
        }}
        onClick={() => {
          if (!folder) {
            return;
          }

          onUpload(folder);
        }}
      >
        <CloudUploadIcon />
        Upload Asset
        {!folder && (
          <Typography variant="body2" style={{ color: "red" }}>
            Please select a folder name to upload asset
          </Typography>
        )}
      </div>
    </Box>
  );
};

ImageLibraryDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onImageSelect: PropTypes.func.isRequired,
  folder: PropTypes.string,
};

ImageLibraryDialog.defaultProps = {
  folder: "uploads",
};

LibraryTab.propTypes = {
  onImageSelect: PropTypes.func.isRequired,
};

UploadTab.propTypes = {
  onUpload: PropTypes.func.isRequired,
};

export default ImageLibraryDialog;
